import { Flex, Stack } from '@chakra-ui/react';
import { ReactComponent as LinkIcon } from 'assets/icons/link.svg';
import { ReactComponent as WebSite } from 'assets/icons/website.svg';
import { useVenngageE1Gate } from 'hooks/useVenngageE1Gate';
import { store, useAppSelector } from 'modules/Editor/store';
import { selectPageCount } from 'modules/Editor/store/infographSelector';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ActionButton } from './ActionButton';
import { ShareTabs } from './SharePanel.config';
import { isResponsiveLinkDisabled } from './ShareResponsiveLink';

interface ShowButtons {
  private?: boolean;
  secure?: boolean;
}

type SharePrivateLinkProps = {
  disabled?: boolean;
  showButtons?: ShowButtons;
  changeTab: (tabId: ShareTabs) => void;
};

export const ShareLinks = ({ disabled = false, changeTab, showButtons }: SharePrivateLinkProps) => {
  const { t } = useTranslation('common_navbar');
  const { venngageE2 } = useVenngageE1Gate();

  const pageCount = useAppSelector(selectPageCount);
  const templateCategory = venngageE2?.templateCategory?.category || '';

  const selectPrivate = useCallback(() => changeTab(ShareTabs.privateLink), [changeTab]);
  const selectSecure = useCallback(() => changeTab(ShareTabs.secure), [changeTab]);

  return (
    <Flex flexDir='column' gap='2' data-testid={'share-private-link'}>
      <Stack direction='row' spacing={2}>
        {showButtons?.private && (
          <ActionButton
            onClick={selectPrivate}
            disabled={disabled}
            text={t('modals.share-panel.sharing.private-link')}
            icon={<LinkIcon />}
          />
        )}

        {showButtons?.secure &&
          !isResponsiveLinkDisabled(store.getState().infograph.widgets, pageCount, templateCategory) && (
            <ActionButton
              onClick={selectSecure}
              disabled={disabled}
              text={t('modals.share-panel.sharing.secure')}
              icon={<WebSite />}
            />
          )}
      </Stack>
    </Flex>
  );
};
